<template lang="pug">
    include SchoolAdminMigrationPreview.pug
</template>

<script>
import _ from "underscore";
import Api from "@/components/services/Api"

export default {
    name: 'SchoolAdminMigrationPreview',
    data() {
        let currentHost = `${window.location.protocol}//${window.location.host}/`;

        return {
            action: null,
            redirect: currentHost + "school-admin/migration-escuela",
            action: currentHost,
            result: null,
            global_errors: [],
            fatal_errors: false,
            pack: null,
        };
    },
    created() {
        const _this = this;

        this.action = Api.getApiUrl() + "/esreps/school-migration/?token=" + this.$store.state.token;
        console.log(this.action);

        // Check if the package has been sent
        if (/\?package=/.test(window.location.href)) {
            let pack = window.location.href.split("?package=")[1].split("&")[0];
            _this.pack = pack;

            Api.preMigrationPackage(this.$store.state.token, pack).then(resp => {
                let result = resp.data.result;
                this.result = result;
                this.fatal_errors = result.fatal_errors;
                this.global_errors = result.errors;

            }).catch();
        }
    }
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "SchoolAdminMigrationPreview";
</style>



// WEBPACK FOOTER //
// src/components/school_admin_migration_preview/SchoolAdminMigrationPreview.vue